import { model as i18n } from '!/i18n'
import { register } from '!/repository'
import { logger } from '@/logger'
import {
  combine,
  createEffect,
  createEvent,
  createStore,
  sample,
} from 'effector'
import { openWindow } from '~/core/router'
import type { PartnerProductDetailsFormatted } from '~/entities/partner-product'

export const selectGoToApp = createEvent<{
  partnerProduct: PartnerProductDetailsFormatted
}>()

const resetSelectedGoToApp = createEvent()

const $selectedGoToApp = createStore<PartnerProductDetailsFormatted | null>(
  null
)
  .on(selectGoToApp, (_, selectedItem) => selectedItem.partnerProduct)
  .reset(resetSelectedGoToApp)

const closePopup = createEvent()
const $isPopupOpened = $selectedGoToApp.map(Boolean)

const goToApp = createEvent<string>()

const goToAppFx = createEffect((url: string | null | undefined) => {
  if (url) {
    const handler = openWindow(url, 'partner_program')
    if (handler) return handler
  }
  throw new Error('Failed to open window')
})

sample({
  clock: goToApp,
  source: $selectedGoToApp,
  fn: (selectedGoToApp) => selectedGoToApp?.purchaseInfo?.partnerProductLink,
  target: goToAppFx,
})

sample({
  clock: goToAppFx.done,
  target: closePopup,
})
sample({
  clock: goToAppFx.failData,
  fn: (error) => ['failed to open shopping cart window', error],
  target: logger.errorFx,
})

sample({
  clock: closePopup,
  target: resetSelectedGoToApp,
})

const $partnerProgramPopupTranslations = combine(i18n.$t, ({ t }) => ({
  title: t('go_to_app_header'),
  description: t('go_to_app_description'),
  button: t('go_to_app'),
}))

register(closePopup, 'payment/partner/go/closePopup')
register(goToApp, 'payment/partner/go/goToApp')
register($isPopupOpened, '$payment/partner/go/isPopupOpened')
register(
  $partnerProgramPopupTranslations,
  '$payment/partner/go/partnerProgramPopupTranslations'
)
